import { render, staticRenderFns } from "./SaveVersionDialog.vue?vue&type=template&id=3b14a5c9&scoped=true&"
import script from "./SaveVersionDialog.vue?vue&type=script&lang=js&"
export * from "./SaveVersionDialog.vue?vue&type=script&lang=js&"
import style0 from "./SaveVersionDialog.vue?vue&type=style&index=0&id=3b14a5c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b14a5c9",
  null
  
)

export default component.exports